import { render } from "./functional_information_debts.vue?vue&type=template&id=ef004c3a&scoped=true"
import script from "./functional_information_debts.vue?vue&type=script&lang=js"
export * from "./functional_information_debts.vue?vue&type=script&lang=js"

import "./functional_information_debts.vue?vue&type=style&index=0&id=ef004c3a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef004c3a"]])

export default __exports__